/** 测评大厅：双列卡片长廊 */
export const LOVE_ASSESS_ITEMS = [
  {
    key: "map",
    title: "AI爱情地图",
    bannerTitle: "认识自己，看见期待",
    bannerSub: "自我认知卡 + 择偶期望卡，画出你的爱情坐标",
    cta: "点击开始 ▶",
    price: "免费",
    gradient: "from-rose-400 via-fuchsia-500 to-violet-500",
    accent: "#fff",
  },
  {
    key: "languages",
    title: "爱的五种语言",
    bannerTitle: "你最能感受到爱的方式是？",
    bannerSub: "30道迫选题，找到你的主要爱语",
    cta: "点击测试 ▶",
    price: "免费",
    gradient: "from-amber-400 via-rose-400 to-violet-500",
    accent: "#fff",
  },
  {
    key: "fruit",
    title: "测测你的爱情性格水果是什么",
    bannerTitle: "测测你的爱情性格水果是什么？",
    bannerSub: "三分钟爱情性格测试，找到你的最佳匹配",
    cta: "点击测试 ▶",
    price: "免费",
    gradient: "from-teal-300 via-cyan-200 to-emerald-200",
    accent: "#0f766e",
    darkText: true,
  },
];

export default function LoveAssessGallery({ onSelect }) {
  return (
    <section className="space-y-5 animate-[fadeIn_0.35s_ease]">
      <header className="space-y-1">
        <h1 className="text-2xl font-extrabold text-gray-800">测评</h1>
        <p className="text-sm text-gray-500">选一个开始，认识自己的爱情模样</p>
      </header>

      <div className="grid grid-cols-2 gap-3 sm:gap-4">
        {LOVE_ASSESS_ITEMS.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => onSelect(item.key)}
            className="text-left bg-white rounded-xl overflow-hidden shadow-md border border-gray-100 hover:shadow-lg hover:-translate-y-0.5 transition active:scale-[0.99]"
          >
            <div
              className={`relative h-36 sm:h-44 bg-gradient-to-br ${item.gradient} p-3 flex flex-col justify-between`}
            >
              <div>
                <p
                  className={`text-sm sm:text-base font-extrabold leading-snug ${
                    item.darkText ? "text-teal-800" : "text-white"
                  }`}
                >
                  {item.bannerTitle}
                </p>
                <p
                  className={`text-[10px] sm:text-xs mt-1.5 leading-relaxed line-clamp-2 ${
                    item.darkText ? "text-teal-700/80" : "text-white/85"
                  }`}
                >
                  {item.bannerSub}
                </p>
              </div>
              <span
                className={`self-start text-[10px] sm:text-xs px-2.5 py-1 rounded-full font-medium ${
                  item.darkText
                    ? "bg-teal-700 text-white"
                    : "bg-black/25 text-white backdrop-blur-sm"
                }`}
              >
                {item.cta}
              </span>
              <div className="absolute right-2 bottom-2 text-3xl sm:text-4xl opacity-90 pointer-events-none">
                {item.key === "map" && "❤️"}
                {item.key === "languages" && "💬"}
                {item.key === "fruit" && "🍒"}
              </div>
            </div>
            <div className="p-3 space-y-3 min-h-[4.5rem] flex flex-col justify-between">
              <h2 className="text-sm font-bold text-gray-800 leading-snug line-clamp-2">
                {item.title}
              </h2>
              <p className="text-rose-500 font-semibold text-sm">{item.price}</p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
